import { RouteRecordRaw } from 'vue-router';

export const ewerpRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../pages/_layout/EwErpLayout.vue'),
    meta: { scope: 'ewerp', title: 'EW Dashboard' },
    children: [
      { path: '', name: 'home', component: () => import('../pages/Dashboard.vue') },
      // {
      //   path: '/login',
      //   name: 'login',
      //   component: () => import('@/components/Archiv/Views/Login.vue'),
      // },
      // {
      //   path: '/logout',
      //   name: 'logout',
      //   component: () => import('@/components/Archiv/Views/Logout.vue'),
      // },
      {
        path: '/bestellungen',
        name: 'bestellungen',
        component: () => import('../pages/Verwaltung/Bestellungen.vue'),
      },
      {
        path: 'bestellung/:id',
        name: 'bestellung.details',
        component: () => import('../pages/Verwaltung/BestellungDetails.vue'),
        props: (route) => ({ id: route.params.id }),
      },

      {
        path: '/herstellung',
        name: 'herstellung',
        component: () => import('../pages/Herstellung/Herstellung.vue'),
      },
      {
        path: '/Material',
        name: 'material',
        component: () => import('../pages/Materialbestellung/Material.vue'),
      },
      {
        path: '/material/flaschen',
        name: 'materialflaschen',
        component: () => import('../pages/Materialbestellung/MaterialFlaschen.vue'),
      },
      {
        path: '/material/kartons',
        name: 'materialkartons',
        component: () => import('../pages/Materialbestellung/MaterialKartons.vue'),
      },
      {
        path: '/material/kapseln',
        name: 'materialkapseln',
        component: () => import('../pages/Materialbestellung/MaterialKapseln.vue'),
      },
      {
        path: '/mdm-sync',
        name: 'mdmSync',
        component: () => import('../pages/MdmSyncView.vue'),
      },
      {
        path: '/produktion',
        name: 'produktion',
        component: () => import('../pages/Produktion/Produktion.vue'),
      },
      {
        path: '/produktion/leistung',
        name: 'produktionsleistung',
        component: () => import('../pages/Produktion/Produktionsleistung.vue'),
      },
      {
        path: '/produktion/maschinen',
        name: 'maschinen',
        component: () => import('../pages/Produktion/Maschinen.vue'),
      },
      {
        path: '/produktion/oee',
        name: 'oee',
        component: () => import('../pages/Produktion/OeeView.vue'),
      },
      {
        path: '/verwaltung',
        name: 'verwaltung',
        component: () => import('../pages/Verwaltung/Verwaltung.vue'),
      },
      {
        path: '/mitarbeiter',
        name: 'mitarbeiter',
        component: () => import('../pages/Mitarbeiter/Mitarbeiter.vue'),
      },
      {
        path: '/lager/fertigwaren',
        name: 'lager',
        component: () => import('../pages/Lager/Lager.vue'),
      },
      {
        path: '/lager/material',
        name: 'materialLager',
        component: () => import('../pages/Lager/MaterialLager.vue'),
      },
      {
        path: '/lager/produktion',
        name: 'produktionLager',
        component: () => import('../pages/Lager/ProduktionLager.vue'),
      },
      {
        path: '/lager/herstellung',
        name: 'herstellungLager',
        component: () => import('../pages/Lager/HerstellungLager.vue'),
      },
    ],
  },
];
